import React from 'react'
import { myData, WorkExperience } from '../Data/Data'

function WorkCard({ item }: { item: WorkExperience }) {
    return (
        <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px dashed #666' }}>
            <h3 style={{ marginBottom: '5px' }}>{item.title}</h3>
            {item.company && (
                <p style={{ margin: '0 0 5px 0' }}>
                    <b>{item.company}</b>
                    {item.location && ` - ${item.location}`}
                    {item.period && ` (${item.period})`}
                </p>
            )}

            <p style={{ whiteSpace: 'pre-line', marginTop: '10px' }}>{item.description}</p>

            {(item.link || item.github) && (
                <p>
                    {item.link && <a href={item.link} target="_blank" rel="noreferrer">[Website]</a>}
                    {item.link && item.github && ' '}
                    {item.github && <a href={item.github} target="_blank" rel="noreferrer">[GitHub]</a>}
                </p>
            )}
        </div>
    )
}

export default function Works() {
    const jobs = myData.filter(item => item.type === 'job')
    const projects = myData.filter(item => item.type === 'project')

    return (
        <div>
            <h2>Work Experience</h2>
            <hr />
            {jobs.map((item) => (
                <WorkCard key={item.id} item={item} />
            ))}

            <h2 style={{ marginTop: '40px' }}>Projects</h2>
            <hr />
            {projects.map((item) => (
                <WorkCard key={item.id} item={item} />
            ))}
        </div>
    )
}
